query invoiceSigningAvailableTags($id: UUID!) {
  invoiceSigningAvailableTags(entityId: $id) {
    nodes {
      id
      name
      badgeName
      badgeColor
    }
  }
}
